import player from 'react-player/lazy/index.js';
const fixUp = player;
const Component = fixUp.default;
export const Player = Component;
//# sourceMappingURL=player.js.map